import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";
import Colors from "../../../config/Colors";

ChartJS.register(ArcElement, Tooltip, Legend);

interface IOperatorDashboardDoughnutProps {
  packages: IOperatorCasesOverview;
}

export function OperatorDashboardDoughnut({
  packages,
}: IOperatorDashboardDoughnutProps) {
  const data = {
    labels: ["Resolved cases", "Unresolved cases"],
    datasets: [
      {
        label: "# of subscribers",
        data: [packages.resolvedCases, packages.unresolvedCases],
        backgroundColor: [`${Colors.appMainColor}`, `${Colors.secondaryColor}`],
        borderColor: [`${Colors.appMainColor}`, `${Colors.secondaryColor}`],
        borderWidth: 1,
        hoverBorderWidth: 20,
      },
    ],
  };
  return (
    <div
      style={{ background: "#FFFFFF" }}
      className="shadow-5 surface-card border-round px-3"
    >
      <div className="w-12 flex flex-row justify-content-between align-items-center">
        <div
          className="pt-3"
          style={{
            fontStyle: "normal",
            fontWeight: 700,
            fontSize: "18px",
            lineHeight: "27px",
            color: `${Colors.mainTextColor}`,
          }}
        >
          Cases overview
        </div>
      </div>
      <div className="pb-2">
        <Doughnut
          data={data}
          options={{
            responsive: true,
            aspectRatio: 2,
            maintainAspectRatio: true,
            plugins: {
              legend: {
                display: true,
                position: "right" as const,
                align: "center",
                labels: {
                  usePointStyle: true,
                  padding: 30,
                },
              },
            },
          }}
        />
      </div>
    </div>
  );
}
